import { CLIENT } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export const ADP_RATE_MAPPINGS = `${CLIENT}/adp-rate-mappings`;

export interface AdpRateMappingProperties {
	clientFullName?: string;
	clientId?: string;
	id: string;
	rateId: string;
	serviceCodeId?: string;
	serviceCodeName?: string;
	userFullName?: string;
	userId: string;
}

export interface AdpRateMappingCreateProperties {
	clientId?: string;
	rateId: string;
	serviceCodeId?: string;
	userId: string;
}

export const AdpRateMapping = {
	getAll: (userId?: string) =>
		FetchAPI.getJson({ urlStr: `${ADP_RATE_MAPPINGS}${userId ? `?userId=${userId}` : ''}` }),
	getServiceMappings: (userId?: string) =>
		FetchAPI.getJson({ urlStr: `${ADP_RATE_MAPPINGS}/service-code-mappings${userId ? `?userId=${userId}` : ''}` }),
	get: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${ADP_RATE_MAPPINGS}/${id}`,
		}),
	create: (data: AdpRateMappingCreateProperties) =>
		FetchAPI.postJson({
			urlStr: data.serviceCodeId ? `${ADP_RATE_MAPPINGS}/service-code-mappings` : ADP_RATE_MAPPINGS,
			data,
		}),
	update: (id: string, data: AdpRateMappingCreateProperties) =>
		FetchAPI.putJson({
			urlStr: `${ADP_RATE_MAPPINGS}${data.serviceCodeId ? '/service-code-mappings' : ''}/${id}`,
			data,
		}),
	delete: (id: string, serviceCode = false) =>
		FetchAPI.deleteJson({
			urlStr: `${ADP_RATE_MAPPINGS}${serviceCode ? '/service-code-mappings' : ''}/${id}`,
		}),
	importMappings: (file: File) => {
		const data = new FormData();
		data.append('spreadsheet', file);

		return FetchAPI.post({ urlStr: `${ADP_RATE_MAPPINGS}/import`, data });
	},
	downloadTemplate: () => FetchAPI.getJson({ urlStr: `${ADP_RATE_MAPPINGS}/import-template` }),
};
